module.exports = __webpack_public_path__ + "img/ESG_01.bcf085a4.png";